/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';

const initialState_preset = [
    {
        id: '',
        il_ocean_import_id: '',
        name: '',
        intermodal: false,
        pre_alert: false,
        isf: false,
        hbl_release: false,
        customs: false,
        ocean_freight: false,
        arrival_notice: false,
        pierpass: false,
        delivery_order: false,
        proof: false,
        invoice: false,
        crdr: false,
    },
];

const oimPresetUpdateSlice = createSlice({
    name: 'oimPresetUpdateForm',
    initialState: initialState_preset,
    reducers: {
        setPresetFormData: (state, action) => {
            return action.payload;
        },
        setPresetUpdateData: (state, action) => {
            const payload = action.payload;

            if (Array.isArray(payload)) {
                // 전체 삭제 신호: [{il_trade_partner_id: 22}] 형태 감지
                if (payload.length === 1 && !payload[0].id) {
                    const targetPartnerId = payload[0].il_trade_partner_id;
                    return state.filter((item) => item.il_trade_partner_id !== targetPartnerId);
                }

                const incomingIds = payload.map((item) => item.id);
                const targetPartnerId = payload[0]?.il_trade_partner_id;

                // 같은 화주 중에서만 삭제
                for (let i = state.length - 1; i >= 0; i--) {
                    if (state[i].il_trade_partner_id === targetPartnerId && !incomingIds.includes(state[i].id)) {
                        state.splice(i, 1);
                    }
                }

                // update or 추가
                payload.forEach((updatedItem) => {
                    const index = state.findIndex((item) => item.id === updatedItem.id);
                    if (index !== -1) {
                        state[index] = updatedItem;
                    } else {
                        state.push(updatedItem);
                    }
                });
            } else {
                const index = state.findIndex((item) => item.id === payload.id);
                if (index !== -1) {
                    state[index] = payload;
                } else {
                    state.push(payload);
                }
            }
        },
    },
});

export const { setPresetFormData, setPresetUpdateData } = oimPresetUpdateSlice.actions;
export default oimPresetUpdateSlice.reducer;
